<div class="card bg-light">
  <div class="card-body">
    <h5 class="card-title">{{name}}</h5>
    <p><ng-container i18n>Version:  </ng-container>{{version}}<span *ngIf="buildDate">&nbsp; {{buildDate}}</span></p>
  </div>
</div>
